import { useState } from "react";
import { _SecopInformation, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { toast } from "react-toastify";
import { Modal } from "../../../theme/Component/Modal";
import { BasicTable } from "../../../theme/Component/BasicTable";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";

export const SecopPortfolio = () => {

    const { instance, bean, setBean, lista, setLista, validateForm, addRequiredFields, isRequired, isMissing } = useDataBean(_SecopInformation)

    const [porta, setPorta] = useState<any>({});
    const [filter, setFilter] = useState<any>({});

    const modal = useModal("Portafolios Encontrados", MODAL_LG)
    const [page, setPage] = useState(1);
    const pageSize = 20;

    const getLista = (currentPage = page) => {
        instance.getPortfolioByID( filter.Portafolio, currentPage, pageSize).then(
            (resp) => {
                if (resp.length == 1) {
                    setBean(resp[0].DataBeanProperties);
                } else {
                    setBean({});
                }
                setLista(resp);
                setPage(currentPage);
            }).catch(err => toast.error(err));
    }

    const formatCurrency = (value: any) => {
        const num = parseFloat(value);
        if (isNaN(num)) return value;
        return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(num);
    };

    const formatDate = (dateStr: string) => {
        if (!dateStr || dateStr === "Sin Descripcion") return "No definida";
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' });
        } catch (e) {
            return dateStr;
        }
    };

    const head = [
        { title: 'Nit', property: 'nit_entidad', visible: true },
        { title: 'Entidad', property: 'entidad', visible: true },
        { title: 'Fase', property: 'fase', visible: true },
        { title: 'Procedimiento', property: 'descripci_n_del_procedimiento', visible: true },
    ];


    const selectItem = () => {
        setBean({ ...porta });
        modal.close();
    }

    return (
        <BasicPage titulo="Información de Protafolios (SECOP)">
            <div className="row">
                <div className="col-md-6">
                    <label className={`${isMissing('Portafolio') ? 'has-error' : ''}`} >ID del Portafolio{isRequired('Portafolio') ? <span className="text-danger">*</span> : ''}</label>
                    <input className="form-control" type="text" value={filter.Portafolio} onChange={(e) => { setFilter({ ...filter, Portafolio: e.target.value }) }} />
                </div>

                <div className="col-md-2">
                    <BasicButton eventClick={() => { setPage(1); getLista(1); }} icon="ri-search-line" children={`Buscar`} useMargin />
                </div>


                {lista.length > 1 &&
                    <div className="col-md-12">
                        < label >Portafolios Disponibles</label>
                        <input
                            type="text"
                            className="form-control"
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder="Buscar..."
                            value={bean.id_del_portafolio}
                            onClick={() => { modal.open(); }}
                        />

                        <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="d-flex justify-content-between align-items-center mt-3">

                                        <button
                                            className="btn btn-outline-secondary"
                                            disabled={page === 1}
                                            onClick={() => getLista(page - 1)}
                                        >
                                            ← Anterior
                                        </button>

                                        <span className="fw-bold">
                                            Página {page}
                                        </span>

                                        <button
                                            className="btn btn-outline-primary"
                                            disabled={lista.length < pageSize}
                                            onClick={() => getLista(page + 1)}
                                        >
                                            Siguiente →
                                        </button>

                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <BasicTable body={lista} head={head} rowSet={setPorta} customRows={pageSize} />
                                </div>
                            </div>
                        </Modal>
                    </div>
                }

                {bean.id_del_portafolio ?
                    <div className="col-md-12 mt-2">
                        <div className="card-header py-3">
                            <h5 className="mb-0">
                                <i className="ri-information-line me-2"></i>
                                Detalles Proceso - {bean.referencia_del_proceso}
                            </h5>
                        </div>

                        <div className="card-body p-4">

                            {/* Información General */}
                            <div className="mb-4">
                                <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">
                                    Información General
                                </h6>

                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="text-muted small">Descripción</label>
                                        <p className="fw-medium">{bean.descripci_n_del_procedimiento}</p>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Tipo de Contrato</label><br />
                                        <span className="badge bg-soft-info text-info p-2">
                                            {bean.tipo_de_contrato}
                                        </span>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Modalidad</label>
                                        <p>{bean.modalidad_de_contratacion}</p>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Estado</label><br />
                                        <span className="badge bg-warning text-dark p-2">
                                            {bean.estado_del_procedimiento}
                                        </span>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Fase</label>
                                        <p>{bean.fase}</p>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Entidad</label>
                                        <p>{bean.entidad}</p>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Ubicación</label>
                                        <p>
                                            <i className="ri-map-pin-line me-1"></i>
                                            {bean.ciudad_entidad}, {bean.departamento_entidad}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Valores */}
                            <div className="mb-4">
                                <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">
                                    Valores
                                </h6>

                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="p-3 bg-light rounded-3 text-center">
                                            <label className="text-muted small">Precio Base</label>
                                            <h5 className="text-success fw-bold">
                                                {formatCurrency(bean.precio_base)}
                                            </h5>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="p-3 bg-light rounded-3 text-center">
                                            <label className="text-muted small">Valor Adjudicación</label>
                                            <h5 className="text-info fw-bold">
                                                {formatCurrency(bean.valor_total_adjudicacion)}
                                            </h5>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="p-3 bg-light rounded-3 text-center">
                                            <label className="text-muted small">Duración</label>
                                            <h5 className="fw-bold">
                                                {bean.duracion} {bean.unidad_de_duracion}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Fechas */}
                            <div className="mb-4">
                                <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">
                                    Fechas
                                </h6>

                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label className="text-muted small">Publicación</label>
                                        <p>{formatDate(bean.fecha_de_publicacion_del)}</p>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Última Publicación</label>
                                        <p>{formatDate(bean.fecha_de_ultima_publicaci)}</p>
                                    </div>

                                    <div className="col-md-4">
                                        <label className="text-muted small">Adjudicación</label>
                                        <p>{formatDate(bean.fecha_adjudicacion)}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Proveedor / Estado */}
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">
                                        Proveedor
                                    </h6>
                                    <div className="p-3 border rounded-3">
                                        <p className="fw-bold">{bean.nombre_del_proveedor}</p>
                                        <p className="small text-muted">
                                            NIT: {bean.nit_del_proveedor_adjudicado}
                                        </p>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <h6 className="text-primary border-bottom pb-2 mb-3 fw-bold">
                                        Estado del Proceso
                                    </h6>
                                    <div className="p-3 border rounded-3">
                                        <p className="fw-bold">{bean.estado_resumen}</p>
                                        <p className="small text-muted">
                                            Adjudicado: {bean.adjudicado}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Botón */}
                            <div className="mt-4 text-center">
                                <a
                                    href={bean.urlproceso}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-primary px-4 rounded-pill"
                                >
                                    <i className="ri-external-link-line me-2"></i>
                                    Ver proceso en SECOP
                                </a>
                            </div>

                        </div>

                    </div>
                    :
                    <div className="text-center p-5 bg-light rounded-3 mt-2">
                        <i className="ri-search-eye-line display-4 text-muted"></i>
                        <p className="mt-2">Sin resultados...</p>
                    </div>
                }
            </div>
        </BasicPage>
    );
}